import React, { useCallback } from 'react';
import SingleSelectSearchDropdown from '../ManageDealDrawer/Components/SingleSelectSearchDropdown/SingleSelectSearchDropdown';
import { Mixpanel } from '../../utils/mixpanel';
import styles from './FilteredViewsButton.module.scss';

export interface FilteredViewOption {
    label: string;
    value: string;
    endLabel?: string;
    columns?: string[];
}

interface ViewSelectorProps {
    options: FilteredViewOption[];
    selectedView: FilteredViewOption | null;
    onViewSelect: (option: FilteredViewOption | null) => void;
    isLoading: boolean;
    error: string | null;
    disabled?: boolean;
    userData?: any;
    organizationId?: string;
    source: string;
    countAppliedFilters: (filters: any) => number;
    filterMapMemo: Map<string, any>;
}

const ViewSelector: React.FC<ViewSelectorProps> = ({
    options,
    selectedView,
    onViewSelect,
    isLoading,
    error,
    disabled = false,
    userData,
    organizationId,
    source,
    countAppliedFilters,
    filterMapMemo,
}) => {
    const getPlaceholderText = useCallback(() => {
        if (isLoading) return 'Loading views...';
        if (error) return 'Error loading views';
        return 'Select View';
    }, [isLoading, error]);

    const handleViewSelect = useCallback(
        (option: FilteredViewOption | null) => {
            if (option?.value) {
                const filterData = filterMapMemo.get(option.value);
                if (filterData) {
                    // Mixpanel tracking for view selection
                    Mixpanel.track('View Selected', {
                        currentURL: window.location.href,
                        user_email: userData?.primaryEmail,
                        filters_applied: countAppliedFilters(filterData.filters),
                        pno_id: organizationId,
                        view_name: option.label,
                        source,
                    });
                }
            }

            onViewSelect(option);
        },
        [onViewSelect, filterMapMemo, userData?.primaryEmail, organizationId, source, countAppliedFilters],
    );

    return (
        <div className={styles.ViewSelectorContainer}>
            <SingleSelectSearchDropdown
                options={options}
                selectedItem={selectedView}
                onSelect={handleViewSelect}
                selectedItemStyle={{
                    background: 'transparent',
                    fontFamily: 'Gilroy-Semibold,sans-serif',
                    fontSize: '0.75rem',
                    padding: 0,
                    maxWidth: '9rem',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                }}
                placeholder={getPlaceholderText()}
                wrapperStyle={{ width: '15.5rem', backgroundColor: '#ffffff', height: '2.625rem' }}
                disabled={isLoading || disabled}
                clearable={true}
                placeholderStyle={{
                    fontFamily: 'Gilroy-SemiBold',
                    fontSize: '0.875rem',
                }}
            />
        </div>
    );
};

export default ViewSelector;
